export default __webpack_public_path__ + "static/media/BOM-comp-image.fab1e967.png";